(function() {
  angular.module('cfn').controller('calendarPopupController', [
    '$scope',
    '$rootScope',
    '$log',
    '$http',
    'dialog',
    'entry',
    'persons',
    '$dialog',
    'i18nFilter',
    function(
      $scope,
      $rootScope,
      $log,
      $http,
      dialog,
      entry,
      persons,
      $dialog,
      i18nFilter
    ) {
      // list of persons defined for this task
      $scope.persons = persons;
      $scope.entry = entry;
      $scope.showPersonRow = !$scope.entry.private_;
      $scope.isFormValid = true;

      if (!$scope.entry.person) {
        $scope.entry.person = $rootScope.credentials.person;
        $scope.entry.personId = $rootScope.credentials.person.id;
      }

      $scope.setPerson = function(person) {
        var inList = false;
        $.each($scope.persons, function(k, v) {
          if (v.id == person.id) {
            inList = true;
          }
        });
        if (!inList) $scope.persons.push(person);

        $scope.entry.person = person;
        $scope.entry.personId = person.id;
        $scope.entry.personCombinedName = person.combinedName;

        if (!$scope.checkIsValid()) {
          $scope.isValid = false;
        }
        $log.debug($scope.entry);
      };

      $scope.removePerson = function(person) {
        var list = [];
        $.each($scope.persons, function(k, v) {
          if (v.id != person.id) {
            list.push(v);
          }
        });
        $scope.persons = list;
      };

      $scope.ok = function() {
        // TODO: check more then only person..
        if (!$scope.entry.person) {
          $dialog
            .messageBox(
              i18nFilter(
                'fe.calendar.noPersonSelected.title',
                'Eintrag kann nicht erstellt werden'
              ),
              i18nFilter(
                'fe.calendar.noPersonSelected.message',
                'Es muß eine Person ausgewählt sein'
              ),
              [
                {
                  result: 'ok',
                  label: i18nFilter('fe.common.ok', 'OK'),
                  cssClass: 'btn-primary'
                }
              ]
            )
            .open();
        } else if ($scope.entry.startDate > $scope.entry.endDate) {
          $dialog
            .messageBox(
              i18nFilter(
                'fe.calendar.noPersonSelected.title',
                'Eintrag kann nicht erstellt werden'
              ),
              i18nFilter(
                'fe.calendar.message.endDateBeforeStartDate',
                'Startdatum liegt hinter dem Enddatum.'
              ),
              [
                {
                  result: 'ok',
                  label: i18nFilter('fe.common.ok', 'OK'),
                  cssClass: 'btn-primary'
                }
              ]
            )
            .open();
        } else {
          dialog.close({
            result: 'ok',
            entry: $scope.entry,
            persons: $scope.persons
          });
        }
      };

      $scope.cancel = function() {
        dialog.close({ result: 'cancel' });
      };

      $scope.deleteEvent = function() {
        dialog.close({ result: 'delete', eventId: $scope.entry.id });
      };

      /**
       * Validates the form entries
       */
      $scope.alert = null;
      $scope.checkIsValid = function() {
        if (!$scope.entry.subject) {
          return false;
        } else if (!$scope.entry.person) {
          $rootScope.alertController.addTemporaryAlert(
            i18nFilter(
              'fe.calendar.noPersonSelected.message',
              'Es muß eine Person ausgewählt sein.'
            ),
            'error'
          );
          return false;
        } else if ($scope.entry.startDate > $scope.entry.endDate) {
          $scope.alert = $rootScope.alertController.addTemporaryAlert(
            i18nFilter(
              'fe.calendar.message.endDateBeforeStartDate',
              'Startdatum liegt hinter dem Enddatum.'
            ),
            'error'
          );
          return false;
        } else if (
          $scope.entry.startDate &&
          $scope.entry.endDate &&
          $scope.entry.person &&
          $scope.entry.reminderBefore >= 0
        ) {
          $rootScope.alertController.closeAlert($scope.alert);
          return true;
        }
      };

      $scope.$watch(
        'entry',
        function(newValue, oldValue) {
          $scope.isFormValid = $scope.checkIsValid();
        },
        true
      );

      $scope.$watch('entry.private_', function(newValue, oldValue) {
        if (newValue == oldValue) return;

        if (newValue === true) {
          var p = $scope.persons;
          $scope.persons = [];
          $scope.persons.push(p[0]);
        }
      });

      return ($scope.calendarPopupController = this);
    }
  ]);
})();
